import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Box, Grid } from '@mui/material';
import { useURLparams } from '@hooks';
import { Table } from '@molecules';
import { COLUMNS, DEFAULT_ROWS_PER_PAGE } from './constants';
import SearchBoxClientsMoves from './SearchBoxClientsMoves';
import styles from './styles';

/**
 * ClientMovementsTable component renders a table with client or area movements data.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {string} props.idArea
 * @param {boolean} props.filtersOpen
 * @param {func} props.setFiltersOpen
 * @param {boolean} props.isLoading
 * @param {object} props.data
 * @param {func} props.handlePageChange
 * @param {func} props.handleRowsPerPageChange
 * @param {func} props.onFiltersFormSubmit
 * @returns {JSX.Element} - The rendered component.
 */
const ClientMovementsTable = ({
  idArea,
  filtersOpen,
  setFiltersOpen,
  isLoading,
  data,
  handlePageChange,
  handleRowsPerPageChange,
  onFiltersFormSubmit,
}) => {
  const { params, setURLparams } = useURLparams();
  const navigate = useNavigate();

  /** Navigate to adjustment detail page */
  const navigateToAdjustmentDetail = (data) => {
    data.customerTransactionType === 'ADJUSTMENT' &&
      navigate(`/clientes/detalle-ajuste/${data.id}`, { state: data });
  };

  return (
    <Grid container>
      <Grid item xs={12} xl={12} sx={styles.tabGrid}>
        <Box sx={styles.boxContainer}>
          <SearchBoxClientsMoves
            isLoading={isLoading}
            filtersOpen={filtersOpen}
            setFiltersOpen={setFiltersOpen}
            setURLparams={setURLparams}
            params={params}
            onSubmit={onFiltersFormSubmit}
            disabledDownload={!data?.page.length}
            idArea={idArea}
          />
          <Box>
            <Table
              count={data?.totalCount || 0}
              items={data?.page}
              columns={COLUMNS}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleRowsPerPageChange}
              page={params.page || 1}
              rowsPerPage={params.limit || DEFAULT_ROWS_PER_PAGE}
              onItemClick={navigateToAdjustmentDetail}
            />
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

ClientMovementsTable.propTypes = {
  idArea: PropTypes.string,
  filtersOpen: PropTypes.bool,
  setFiltersOpen: PropTypes.func,
  isLoading: PropTypes.bool,
  data: PropTypes.object,
  handlePageChange: PropTypes.func,
  handleRowsPerPageChange: PropTypes.func,
  onFiltersFormSubmit: PropTypes.func,
};
export default ClientMovementsTable;
